export const processImage = async (
  pipeline: {
    (canvas: HTMLCanvasElement, width: number, height: number): Promise<HTMLCanvasElement>;
  }[],
  canvas: HTMLCanvasElement,
  width: number,
  height: number,
): Promise<HTMLCanvasElement> => {
  for (let index = 0; index < pipeline.length; index++)
    canvas = await pipeline[index](canvas, width, height);
  return canvas;
};
